import * as React from "react";
import styled from "styled-components";
import { useMemo } from "react";
import { Field, useFormikContext } from "formik";
import { Select } from "components/common";
import { Input } from "components/bootstrap";
import { defaultCompare } from "logic/DefaultCompare";
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const SortConfiguration = ({
  name: attributeName,
  directions,
  columns,
  columnTitle = (column) => column,
  directionTitle = (direction) => direction
}) => {
  const { values } = useFormikContext();
  const columnOptions = useMemo(
    () => columns.map((col) => ({ value: col, label: columnTitle(col) })).sort(({ label: label1 }, { label: label2 }) => defaultCompare(label1, label2)),
    [columnTitle, columns]
  );
  const directionOptions = useMemo(
    () => directions.map((col) => ({ value: col, label: directionTitle(col) })).sort(({ label: label1 }, { label: label2 }) => defaultCompare(label1, label2)),
    [directionTitle, directions]
  );
  const isUnknownColumn = values[attributeName].field && !columns.includes(values[attributeName].field);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Field, { name: `${attributeName}.field` }, ({ field: { value, onChange, name } }) => /* @__PURE__ */ React.createElement(Input, { id: "sort-configuration-column", label: "Column", labelClassName: "col-sm-3", wrapperClassName: "col-sm-9" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "sort-configuration-column-select",
      placeholder: "Select a column",
      options: columnOptions,
      clearable: false,
      size: "small",
      onChange: (newColumn) => onChange({ target: { value: newColumn, name } }),
      value: isUnknownColumn ? "Unknown" : value
    }
  ))), /* @__PURE__ */ React.createElement(Field, { name: `${attributeName}.direction` }, ({ field: { value, onChange, name } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "sort-configuration-direction",
      label: "Direction",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "sort-configuration-direction-select",
        placeholder: "Select a direction",
        options: directionOptions,
        clearable: false,
        size: "small",
        onChange: (newDirection) => onChange({ target: { value: newDirection, name } }),
        value
      }
    )
  )));
};
export default SortConfiguration;
